import EventHandler from '../../events/event_handler';
import ImportedInputDocumentEvents from './input_document_events';

export const InputDocumentEvents = ImportedInputDocumentEvents;
export const InputDocumentEventHandler = new EventHandler(Object.values(InputDocumentEvents));

export default InputDocumentEventHandler;
